import React, { useContext } from 'react';
import SearchContext from '../data/FunnelbackContext';
import DisplayMode from './_DisplayMode';
import SearchResultsToDisplay from './_SearchResultsToDisplay';
import SortByFilter from './_SortByFilter';
import styles from '../../css/functional.module.scss';

/**
 * Search Summary Component
 *
 * @returns {JSX.Element|null}
 * @constructor
 */
function SearchSummary() {
    const {
        isFetching,
        resultsSummary: { totalMatching, currStart, currEnd, partiallyMatching, collapsed, query },
    } = useContext(SearchContext);

    const displayModeFn = DisplayMode();
    const numSearchResults = SearchResultsToDisplay();
    const sortByFilterFn = SortByFilter();

    if (isFetching) {
        return (
            <>
                <div className="sr-only">Loading...</div>
                <div className="funnelback-instant-search-summary--loading" />
            </>
        );
    }

    if (query === '' || query === undefined) {
        return null;
    }

    const noResultsPartial =
        totalMatching === 0 ? (
            <>
                <strong>Showing {totalMatching}</strong> search results for term &quot;<strong>{query}</strong>&quot;
            </>
        ) : (
            ''
        );

    const resultsPartial =
        totalMatching > 0 ? (
            <>
                <strong>
                    Showing {currStart}-{currEnd}
                </strong>{' '}
                of <strong>{totalMatching}</strong> search results for term &quot;<strong>{query}</strong>&quot;
            </>
        ) : (
            ''
        );

    const partialMatchPartial =
        partiallyMatching > 0 ? (
            <>
                {' '}
                where <strong>{totalMatching}</strong> match all words and <strong>{partiallyMatching}</strong> match some words.
            </>
        ) : (
            ''
        );

    const collapsedPartial =
        collapsed > 0 ? (
            <>
                <strong>{collapsed}</strong> very similar results included.
            </>
        ) : (
            ''
        );

    return (
        <div className={`${styles.summary} funnelback-instant-search-summary`}>
            <div>
                {noResultsPartial}
                {resultsPartial}
                {partialMatchPartial}
                {collapsedPartial}
            </div>
            <div className="funnelback-instant-search-display">
                {sortByFilterFn}
                {numSearchResults}
                {displayModeFn}
            </div>
        </div>
    );
}

export default SearchSummary;
